module.exports = __webpack_public_path__ + "img/demo3-weight-en.e3efeb0d.png";